import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

const FEEDBACK_KEY = process.env.REACT_APP_HISLAND_FEEDBACK_KEY;
const FEEDBACK_ENDPOINT = process.env.REACT_APP_HISLAND_FEEDBACK_ENDPOINT;

export default function FeedbackWidget() {
  const { user, isAuthenticated } = useAuth();
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !user || !FEEDBACK_KEY || !FEEDBACK_ENDPOINT) return;

    const init = async () => {
      if (!scriptLoadedRef.current && !document.getElementById('hisland-feedback-script')) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.id = 'hisland-feedback-script';
          script.src = `${FEEDBACK_ENDPOINT}/widget/feedback.js`;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
        scriptLoadedRef.current = true;
      }

      if (window.HislandFeedback) {
        window.HislandFeedback.init({
          apiKey: FEEDBACK_KEY,
          endpoint: FEEDBACK_ENDPOINT,
          user: {
            email: user.email,
            id: user.id,
          },
          position: 'bottom-right',
        });
      }
    };

    init().catch(() => {});
  }, [isAuthenticated, user]);

  return null;
}
